import { Route } from 'react-router-dom';

import Layout from '../components/layout';
import ProtectedRoute from '../components/ProtectedRoute';

import AllCategories from '../Pages/Products/Category/AllCategories';
import AllProducts from '../Pages/Products/Product/AllProducts';
import ReviewList from '../Pages/Products/Review/ReviewList';
import AllBrand from '../Pages/Products/Brand/AllBrand';
import ImportProduct from '../Pages/Products/Import/ImportProduct';
import NewProduct from '../Pages/Products/Product/NewProduct';
import { hasPermission } from '../utils/functions';

export const ProductRoutes = ({ menuActive, setMenuActive }) => (
  <>
    <Route path="/products" element={
      <ProtectedRoute>
        <Layout activePage='products/all' menuActive={menuActive} setMenuActive={setMenuActive}>
          <AllProducts />
        </Layout>
      </ProtectedRoute>
    } />
    <Route path="/products/all" element={
      <ProtectedRoute>
        <Layout activePage='products/all' menuActive={menuActive} setMenuActive={setMenuActive}>
          <AllProducts />
        </Layout>
      </ProtectedRoute>
    } />
    { hasPermission('productsCategory') && 
      <Route path="/products/category" element={
        <ProtectedRoute>
          <Layout activePage='products/category' menuActive={menuActive} setMenuActive={setMenuActive}>
            <AllCategories />
          </Layout>
        </ProtectedRoute>
      } />
    }

    { hasPermission('productsReview') && 
      <Route path="/products/review" element={
        <ProtectedRoute>
          <Layout activePage='products/review' menuActive={menuActive} setMenuActive={setMenuActive}>
            <ReviewList />
          </Layout>
        </ProtectedRoute>
      } />
    }

    { hasPermission('productsBrand') && 
      <>
        <Route path="/products/brand" element={
          <ProtectedRoute>
            <Layout activePage='products/brand' menuActive={menuActive} setMenuActive={setMenuActive}>
              <AllBrand />
            </Layout>
          </ProtectedRoute>
        } />
      </>
    }    

    <Route path="/products/import" element={
      <ProtectedRoute>
        <Layout activePage='products/import' menuActive={menuActive} setMenuActive={setMenuActive}>
          <ImportProduct />
        </Layout>
      </ProtectedRoute>
    } />
    
    <Route path="/new-product" element={
      <ProtectedRoute>
        <Layout activePage='new-product' menuActive={menuActive} setMenuActive={setMenuActive}>
          <NewProduct />
        </Layout>
      </ProtectedRoute>
    } />
    <Route path="/product/:productId" element={
      <ProtectedRoute>
        <Layout activePage='edit-product' menuActive={menuActive} setMenuActive={setMenuActive}>
          <NewProduct />
        </Layout>
      </ProtectedRoute>
    } />
  </>
);
